import iconOlivia from "../assets/images/app/icon-olivia.png";
import iconOliviaWhite from "../assets/images/app/icon-olivia-white.png";
import iconUser from "../assets/images/app/icon-user.jpg";
import logoDark from "../assets/images/app/keepme.png";
import logoLight from "../assets/images/app/keepme.png";
import mascot from "../assets/images/app/mascot.gif";

export const appImages = {
  iconOlivia: {
    src: iconOlivia,
    alt: "Olivia"
  },
  iconOliviaWhite: {
    src: iconOliviaWhite,
    alt: "Olivia"
  },
  iconUser: {
    src: iconUser,
    alt: "User"
  },
  logoDark: {
    src: logoDark,
    alt: "Logo Dark"
  },
  logoLight: {
    src: logoLight,
    alt: "Logo Light"
  },
  mascot: {
    src: mascot,
    alt: "Mascot"
  }
};

export default appImages;
